import React from 'react'
import { getProjectMaterials, deleteMaterials } from 'utils/FieldMaterialsUtils';
import { useAppContext } from 'hooks/useAppContext';
import Grid from 'components/Custom/Grid'
import SkeletonGrid from 'components/Shared/SkeletonGrid';
import FieldMaterials from 'classes/FieldMaterials';

export default function MaterialGrid() {
  const columns = FieldMaterials.columns.filter(name => name.field !== "Delete")
  const { selectedProject } = useAppContext(); //Getting the App Context
  const title = "Field Materials"
  const getFormPath = () => import('components/Materials/AddMaterials')

  return (
    selectedProject ?
 
    <Grid
        columns={columns}
        title={title}
        getRecords={getProjectMaterials}
        deleteRecord={deleteMaterials}
        selectedProject={selectedProject}
        component="Materials"
        formPath={getFormPath}
        options={{
          pageSize: 10,
          pageSizeOptions: [10, 20, 25]
        }}
        localization={{
          body: { editRow: { deleteText: "Are you sure you'd like to mark this row as inactive?" } }
        }}
      /> : <SkeletonGrid title={title} />
  )
}